// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3DrUu","Open":"SideDrawer_Open__1obRt","Close":"SideDrawer_Close__2Sdtc","Logo":"SideDrawer_Logo__1qq8T"};